import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ComponentsGlobalWebModule,
  FormattedDatePipe,
  GarminGlobalStoreService,
  ModalComponent
} from '@garmin-avcloud/avcloud-fly-web-common/shared';
import { IsFutureDatePipe } from '../features/subscription-management/pipes/is-future-date.pipe';
import { DummieHeaderComponent } from './components/dummie-header/dummie-header.component';
import { FullPageLoaderComponent } from './components/pages/full-page-loader/full-page-loader.component';
import { AccountDisplayPipe } from './pipes/account-display.pipe';
import { MoneyPipe } from './pipes/money.pipe';
import { ObservableStatusPipe } from './pipes/observable-status.pipe';
import { CartService } from './services/cart.service';
import { CollectionsService } from './services/collections.service';
import { DatabasePricingService } from './services/database-pricing.service';
import { DatesService } from './services/dates.service';
import { EnablementPricingService } from './services/enablement-pricing.service';
import { GarminPilotCatalogService } from './services/garmin-pilot-catalog.service';
import { LegacySubscriptionsService } from './services/legacy-subscriptions.service';
import { LinksService } from './services/links.service';
import { LocaleService } from './services/locale.service';
import { MoneyService } from './services/money.service';
import { OrdersService } from './services/orders.service';
import { SkuService } from './services/sku.service';
import { SubscriberService } from './services/subscriber.service';
import { FlyTooltipModule } from './tooltips/tooltip.module';

@NgModule({
  imports: [
    A11yModule,
    CommonModule,
    FormsModule,
    ComponentsGlobalWebModule,
    ModalComponent,
    ReactiveFormsModule,
    FormattedDatePipe,
    AccountDisplayPipe,
    IsFutureDatePipe
  ],
  exports: [
    AccountDisplayPipe,
    DummieHeaderComponent,
    FormattedDatePipe,
    IsFutureDatePipe,
    FormsModule,
    FullPageLoaderComponent,
    ModalComponent,
    MoneyPipe,
    ObservableStatusPipe,
    ReactiveFormsModule,
    FlyTooltipModule
  ],
  declarations: [DummieHeaderComponent, FullPageLoaderComponent, MoneyPipe, ObservableStatusPipe],
  providers: [
    CartService,
    CollectionsService,
    DatabasePricingService,
    DatesService,
    EnablementPricingService,
    GarminGlobalStoreService,
    GarminPilotCatalogService,
    LegacySubscriptionsService,
    LinksService,
    LocaleService,
    MoneyService,
    OrdersService,
    SkuService,
    SubscriberService
  ]
})
export class SharedModule {}
